import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter} from "../../../utils/formatters";
import {componentFilter} from "../../../utils/filters";

class partnerList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid || "partnerList"}
                {...props}
                columns={{
                    //partner_id: {header: 'Partnerkód', width:2, sortable},
                    name: {
                        header: 'Név',
                        width: 3,
                        filterable,
                        sortable
                    },
                    taxid: {
                        header: 'Adószám',
                        width: 2,
                        filterable,
                        sortable
                    },
                    eu_taxid: {
                        header: 'EU adószám',
                        width: 2,
                        filterable,
                        sortable
                    },
                    email: {
                        header: 'Email',
                        width: 2,
                        filterable,
                        sortable
                    },
                    address: {
                        header: 'Cím',
                        width: 3,
                        renderer: AddressFormatter
                    }
                    //component_type: {header: 'Típus', width:1, renderer: (data) => {return partner_types.filter((item) => item.value == data)[0].label;}}
                }}
                orderBy={{field: "name", direction: "ASC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default partnerList;
